import { Container } from 'react-bootstrap';
  
export const BootstrapLayout = (props: any) => (
    <div style={{ verticalAlign: "top", margin: "0px", padding: "0px"}}>
        <Container>
            {props.children}
        </Container>
    </div>
);